import styled from 'styled-components';

export const MeanConsumptionContainer = styled.div`
  background-color: ${(props) => props.theme.color.bg.primary};
  grid-area: meanconsumption;
  h4 {
    color: ${(props) => props.theme.color.ui.orange};
  }
  h2 {
    text-align: center;
  }
  span {
    align-self: center;
    color: ${(props) => props.theme.color.text.quaternary};
  }
`;

export const ChartContainer = styled.div`
  height: 150px;
`;
